import { wrapCreateBrowserRouterV7 } from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';

import ErrorBoundary from 'components/_ErrorBoundary';
import { Signin, ForgotPassword } from 'modules/auth';
import { ClientDetails } from 'modules/client-details';
import { Clients } from 'modules/clients';
import { Home } from 'modules/home';
import { News } from 'modules/news';
import CustomSuspense from 'routes/CustomSuspense';
import ProtectedRoute from 'routes/ProtectedRoute';

import * as clientRoutes from 'constants/clientRoutes';

export const sentryCreateBrowserRouter = import.meta.env.VITE_NODE_ENV !== 'dev'
  ? wrapCreateBrowserRouterV7(createBrowserRouter)
  : createBrowserRouter;

export const router = [
  {
    path: clientRoutes.HOMEPAGE_ROUTE,
    errorElement: <ErrorBoundary />,
    element: <CustomSuspense><Home /></CustomSuspense>,
  },
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: clientRoutes.NEWS_ROUTE,
        errorElement: <ErrorBoundary />,
        element: <CustomSuspense><News /></CustomSuspense>,
      },
      {
        path: clientRoutes.CLIENTS_ROUTE,
        errorElement: <ErrorBoundary />,
        element: <CustomSuspense><Clients /></CustomSuspense>,
      },
      {
        path: clientRoutes.CLIENT_DETAILS_ROUTE,
        errorElement: <ErrorBoundary />,
        element: <CustomSuspense><ClientDetails /></CustomSuspense>,
      },
      {
        path: clientRoutes.CLIENT_DETAILS_BY_ID_ROUTE,
        errorElement: <ErrorBoundary />,
        element: <CustomSuspense><ClientDetails /></CustomSuspense>,
      },
    ],
  },
  {
    path: clientRoutes.SIGNIN_ROUTE,
    errorElement: <ErrorBoundary />,
    element: <CustomSuspense><Signin /></CustomSuspense>,
  },
  {
    path: clientRoutes.FORGOT_PASSWORD_ROUTE,
    errorElement: <ErrorBoundary />,
    element: <CustomSuspense><ForgotPassword /></CustomSuspense>,
  },
];

export const CLIENT_ROUTES = [
  clientRoutes.HOMEPAGE_ROUTE,
  clientRoutes.NEWS_ROUTE,
  clientRoutes.CLIENT_DETAILS_ROUTE,
  clientRoutes.SIGNIN_ROUTE,
  clientRoutes.FORGOT_PASSWORD_ROUTE,
];

export const ADMIN_ROUTES = [
  clientRoutes.HOMEPAGE_ROUTE,
  clientRoutes.NEWS_ROUTE,
  clientRoutes.CLIENTS_ROUTE,
  clientRoutes.CLIENT_DETAILS_BY_ID_ROUTE,
  clientRoutes.SIGNIN_ROUTE,
  clientRoutes.FORGOT_PASSWORD_ROUTE,
];
